import fs from 'node:fs'
import path from 'node:path'
import { stringifyProjectJson } from '@core-engine/utils/json-format.js'
import type { SchemaOwner, SchemaOwnershipIndex } from '@plugin-engine/types.js'

function ownershipPath(cwd: string): string {
  return path.join(cwd, '.betterstart', 'schemas', 'ownership.json')
}

export function loadSchemaOwnershipIndex(cwd: string): SchemaOwnershipIndex {
  const filePath = ownershipPath(cwd)
  if (!fs.existsSync(filePath)) {
    return {
      version: 1,
      schemas: {}
    }
  }

  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as SchemaOwnershipIndex
}

export function saveSchemaOwnershipIndex(cwd: string, index: SchemaOwnershipIndex): void {
  const filePath = ownershipPath(cwd)
  fs.mkdirSync(path.dirname(filePath), { recursive: true })
  fs.writeFileSync(filePath, stringifyProjectJson(index), 'utf-8')
}

export function getSchemaOwner(cwd: string, schemaName: string): SchemaOwner | undefined {
  return loadSchemaOwnershipIndex(cwd).schemas[schemaName]
}

export function setSchemaOwner(cwd: string, schemaName: string, owner: SchemaOwner): void {
  const index = loadSchemaOwnershipIndex(cwd)
  index.schemas[schemaName] = owner
  saveSchemaOwnershipIndex(cwd, index)
}

export function removeSchemaOwner(cwd: string, schemaName: string): void {
  const index = loadSchemaOwnershipIndex(cwd)
  delete index.schemas[schemaName]
  saveSchemaOwnershipIndex(cwd, index)
}
